import { render, staticRenderFns } from "./AddFaq.vue?vue&type=template&id=f886f976"
import script from "./AddFaq.vue?vue&type=script&lang=js"
export * from "./AddFaq.vue?vue&type=script&lang=js"
import style0 from "./AddFaq.vue?vue&type=style&index=0&id=f886f976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports